import { Fragment, useState } from "react";
import { Modal } from "react-bootstrap";
import PrintLink from "../../components/Shipment/Factor/PrintLink";
import SendSMSForFactor from "./SendSMSForFactor";
import EnterSMSFactor from "./EnterSMSFactor";
import useSharedData from "../../hooks/useSharedData";

const DownloadFactor = ({ id, numberParcel }) => {
  const { isAuthed } = useSharedData();
  const [showModalDownload, setShowModalDownload] = useState(false);
  const [enterSMSCode, sendEnterSMSCode] = useState(false);

  return (
    <Fragment>
      {isAuthed && (
        <PrintLink ids={[id]} onFaild={() => setShowModalDownload(true)}>
          دانلود فاکتور
        </PrintLink>
      )}

      {!isAuthed && (
        <button
          onClick={() => setShowModalDownload(true)}
          className="btn btn-outline-primary"
        >
          دانلود فاکتور
        </button>
      )}

      <Modal show={showModalDownload} centered size="lg">
        <Modal.Header>
          <h5 className="mb-0">دریافت فاکتور به وسیله تایید شماره همراه</h5>
        </Modal.Header>
        <Modal.Body>
          {!isAuthed && (
            <p>
              اگر این مرسوله را شما در سامانه آواکس ثبت کردید ، می‌توانید ابتدا
              ورود نمایید و سپس اقدام به دانلود فاکتور کنید. در غیر این صورت:
            </p>
          )}

          {!enterSMSCode && (
            <SendSMSForFactor
              id={id}
              numberParcel={numberParcel}
              onSuccess={() => sendEnterSMSCode(true)}
            />
          )}

          {enterSMSCode && <EnterSMSFactor id={id} />}
        </Modal.Body>
        <Modal.Footer>
          <button
            className="btn btn-danger"
            onClick={() => setShowModalDownload(false)}
          >
            خروج
          </button>
        </Modal.Footer>
      </Modal>
    </Fragment>
  );
};

export default DownloadFactor;
